import { Location } from '../../types/location';
import { Action, SET_LOCATIONS } from './actions';

export default (
  state: Location[] = null as any,
  action: Action
): Location[] => {
  switch (action.type) {
    case SET_LOCATIONS:
      return action.payload;
    default:
      return state;
  }
};
